import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F44336" }}>Problem</span>
            </h2>
            <p>
              The challenge was to create a simple yet entertaining guessing
              game that operates in accordance to a set of intricate rules and
              procedures. At the same time, we also wanted to integrate an
              effective advertising module that could showcase sponsors.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/picture-pick/problem_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={768}
              height={554}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
